import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const allowed = localStorage.getItem("authAllowed") === "true";
  console.log("🔒 PrivateRoute - authAllowed:", allowed);
  console.log(
    "🔒 PrivateRoute - localStorage authAllowed:",
    localStorage.getItem("authAllowed")
  );

  if (allowed) {
    console.log("✅ Acesso autorizado, renderizando dashboard");
    return <Outlet />;
  } else {
    console.log("❌ Acesso negado, redirecionando para login");
    return <Navigate to="/login" />;
  }
};

export default PrivateRoute;
